import { useGetTenantDisplayNamesQuery } from "graphqlBase/userManagement/tenants/__generated__/getTenantDisplayNames";
import { useMemo } from "react";

const useGetTenantNameById = ({ withDeniedTenants = false }: { withDeniedTenants?: boolean }) => {
  const { data } = useGetTenantDisplayNamesQuery({
    variables: { withDeniedTenants },
  });

  const tenantItems = useMemo(() => data?.tenantDisplayNames ?? [], [data]);

  const tenantNameById: { [key: string]: string } = useMemo(() => {
    return tenantItems.reduce<{ [key: string]: string }>((acc, cur) => {
      acc[cur.id] = cur.tenantName;
      return acc;
    }, {});
  }, [tenantItems]);

  const getTenantById = (id: string) => {
    return tenantNameById[id];
  };

  const tenantRoleByTenantId: { [key: string]: string } = useMemo(() => {
    return tenantItems.reduce<{ [key: string]: string }>((acc, cur) => {
      acc[cur.id] = cur.tenantRole;
      return acc;
    }, {});
  }, [tenantItems]);

  const getTenantRoleByTenantId = (id: string) => {
    return tenantRoleByTenantId[id];
  };

  return { tenantNameById, getTenantById, tenantRoleByTenantId, getTenantRoleByTenantId, tenantItems };
};

export default useGetTenantNameById;
